import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "gauge" }
const _hoisted_2 = { class: "gauge-mult mono" }
const _hoisted_3 = { class: "gauge-sub" }
const _hoisted_4 = { class: "rocket-controls" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "rocket-cashout-sats mono"
}
const _hoisted_8 = {
  key: 2,
  class: "rocket-settling"
}
const _hoisted_9 = {
  key: 0,
  class: "rocket-hint"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rocket-skin", _ctx.gaugeClass])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.gaugeText), 1),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.gaugeSub), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.state.phase === 'idle' || _ctx.state.phase === 'resolved')
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "rocket-btn launch",
            disabled: !_ctx.canLaunch,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLaunch && _ctx.onLaunch(...args)))
          }, _toDisplayString(_ctx.state.phase === 'resolved' ? 'LAUNCH AGAIN' : 'LAUNCH 🚀'), 9, _hoisted_5))
        : (_ctx.state.phase === 'climbing')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["rocket-btn cashout", { armed: _ctx.canCashOut }]),
              disabled: !_ctx.canCashOut,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onCashOut && _ctx.onCashOut(...args)))
            }, [
              _createTextVNode(" CASH OUT @ " + _toDisplayString(_ctx.displayMult.toFixed(2)) + "× ", 1),
              (_ctx.cashoutSats !== null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.cashoutSats.toLocaleString()) + " sats ", 1))
                : _createCommentVNode("", true)
            ], 10, _hoisted_6))
          : (_ctx.state.phase === 'settling' || _ctx.state.phase === 'flipping')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " LOCKING IN @ " + _toDisplayString(_ctx.lockedMult.toFixed(2)) + "× ", 1))
            : _createCommentVNode("", true)
    ]),
    (_ctx.state.phase === 'climbing')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (!_ctx.canCashOut)
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "arming at " + _toDisplayString(_ctx.minMult.toFixed(2)) + "×…", 1))
            : (_ctx.state.odds)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "auto cash-out at " + _toDisplayString(_ctx.targetMult.toFixed(2)) + "×", 1))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}